<div class="flex flex-col gap-0.5 w-full">
  @for (log of logList; track $index) {
    <div
      class="log-row flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-opacity hover:opacity-80"
      [class.red-theme-bg-1]="log.severity === 'Error'"
      [class.yellow-theme-bg-1]="log.severity === 'Warning'"
      [class.green-theme-bg-1]="log.severity === 'Success'"
      [class.blue-theme-bg-2]="log.severity === 'Info'"
      [class.red-theme-text-1]="log.severity === 'Error'"
      [class.yellow-theme-text-1]="log.severity === 'Warning'"
      [class.green-theme-text-1]="log.severity === 'Success'"
      [class.blue-theme-text-3]="log.severity === 'Info'"
    >
      @if (log.severity === 'Error') {
        <mat-icon>error</mat-icon>
      }
      @if (log.severity === 'Warning') {
        <mat-icon>warning</mat-icon>
      }
      @if (log.severity === 'Info') {
        <mat-icon>info</mat-icon>
      }
      @if (log.severity === 'Success') {
        <mat-icon>check_circle</mat-icon>
      }
      <div class="flex flex-col min-w-0">
        <span class="truncate">{{ log.message }}</span>
        @if (log.location || log.sheet) {
          <div class="flex gap-3 text-[12px] opacity-70 mt-0.5">
            @if (log.location) {
              <span>Location: {{ log.location }}</span>
            }
            @if (log.sheet) {
              <span>Sheet: {{ log.sheet }}</span>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
